import { Controller } from "stimulus"
import selectize from "selectize"

export default class extends Controller {
  static targets = [ "userId", "playlistId", "addStorePrefix", "storePrefixesDiv" ]

  connect() {
    this.playlistIdValue = this.data.get("playlist-id")
    $(this.userIdTarget).selectize({
      allowEmptyOption: true,
      highlight: false,
      onChange: this.userSelected.bind(this)
    })
    this.userSelected()
  }

  createPlaylistIdSelectize() {
    $(this.playlistIdTarget).selectize({
      allowEmptyOption: true,
      highlight: false,
      preload: true,
      load: this.loadPlaylistIdData.bind(this),
      onLoad: (data) => {
        if (!this.playlistIdSelectizeLoaded) {
          this.playlistIdSelectizeLoaded = true
          this.playlistIdTarget.selectize.setValue(this.playlistIdValue, true)
        }
      }
    })
  }

  destroyPlaylistIdSelectize() {
    const playlistIdSelectize = this.playlistIdTarget.selectize
    if (playlistIdSelectize) {
      playlistIdSelectize.destroy()
    }
  }

  loadPlaylistIdData(value, callback) {
    const user_id = this.userIdTarget.value

    if (user_id) {
      $.ajax({
        url: this.data.get("playlists-url").concat(".json"),
        type: "GET",
        data: { q: { user_id, value } },
        success: (data) => {
          callback(data.map(([text, value]) => { return { text, value } }))
        },
        error: callback
      })
    }
  }

  userSelected() {
    this.destroyPlaylistIdSelectize()
    this.playlistIdSelectizeLoaded = false
    this.createPlaylistIdSelectize()
  }

  storePrefixAdded(event) {
    if (this.addStorePrefixTarget.value.length == 2) {
      const regexp = new RegExp("store_prefix_value", "g")
      const prefixItem = $(event.target).data("field").replace(regexp, this.addStorePrefixTarget.value.toUpperCase())
      $(this.storePrefixesDivTarget).append(prefixItem)
    }
    $(this.addStorePrefixTarget).val("")
    $(event.target).blur()
  }
}
